import { ReactNode } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { ChatContextProvider } from "../features/chat";
import { SettingsProvider } from "../features/settings";
import { ireckonuTheme } from "./theme";
import { UrlParamsProvider } from "./context/url-params-context";
import { DEFAULT_USERNAME } from "../features/settings";

interface ProvidersProps {
  children: ReactNode;
  functionKey?: string;
  username?: string;
}

export function Providers({ children, functionKey, username }: ProvidersProps) {
  const usernameValue = username || DEFAULT_USERNAME;
  return (
    <ThemeProvider theme={ireckonuTheme}>
      {functionKey ? (
        <UrlParamsProvider functionKey={functionKey} username={usernameValue}>
          <SettingsProvider>
            <ChatContextProvider>{children}</ChatContextProvider>
          </SettingsProvider>
        </UrlParamsProvider>
      ) : (
        children
      )}
    </ThemeProvider>
  );
}
